// Firebase configuration for authentication
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth';

// Firebase config - Replace with your actual Firebase project values
// Note: These are safe to expose in frontend code
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBvb_zDPZct0-2XZolAOzSNyQeBJ08G3UY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "camera-monitoring-system-dccc8.firebaseapp.com", 
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "camera-monitoring-system-dccc8",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "camera-monitoring-system-dccc8.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "284051326554",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:284051326554:web:0f2aa5de23025fab647a63"
};

// Debug: Log the config to check if environment variables are loaded
console.log('🔧 [FIREBASE CONFIG] Environment variables loaded:', {
  hasApiKey: !!process.env.REACT_APP_FIREBASE_API_KEY,
  hasAuthDomain: !!process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  hasProjectId: !!process.env.REACT_APP_FIREBASE_PROJECT_ID,
  apiKeyPreview: process.env.REACT_APP_FIREBASE_API_KEY ? process.env.REACT_APP_FIREBASE_API_KEY.substring(0, 10) + '...' : 'NOT_FOUND'
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Auth functions
export const signInWithGooglePopup = () => signInWithPopup(auth, googleProvider);

export const createAuthUserWithEmailAndPassword = async (email, password) => {
  if (!email || !password) return;
  return await createUserWithEmailAndPassword(auth, email, password);
};

export const signInAuthUserWithEmailAndPassword = async (email, password) => {
  if (!email || !password) return;
  return await signInWithEmailAndPassword(auth, email, password);
};

export const signOutUser = async () => await signOut(auth);

export default app;
